import { render, staticRenderFns } from "./ModalityTable.vue?vue&type=template&id=6d98fb98"
import script from "./ModalityTable.vue?vue&type=script&lang=js"
export * from "./ModalityTable.vue?vue&type=script&lang=js"
import style0 from "./ModalityTable.vue?vue&type=style&index=0&id=6d98fb98&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports